import { render, staticRenderFns } from "./EditSaleRate.vue?vue&type=template&id=788d09f4&scoped=true"
import script from "./EditSaleRate.vue?vue&type=script&lang=js"
export * from "./EditSaleRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788d09f4",
  null
  
)

export default component.exports